import React from 'react'

import Box, { BoxProps } from '@material-ui/core/Box'
import { Skeleton } from '@material-ui/lab'

const CheckboxSkeleton = (props: BoxProps) => {
  return (
    <Box display="flex" width="100%" {...props}>
      <Box mr={1}>
        <Skeleton variant="rect" width={24} height={24} />
      </Box>
      <Skeleton width="100%" height={24} />
    </Box>
  )
}

export default CheckboxSkeleton
